import { useState } from 'react';
import { useNavigate } from 'react-router-dom';

export const useWorkspaces = () => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const navigate = useNavigate();

  const goToWorkspaceMap = () => {
    //ReactPixel.trackCustom('clickReservationButton', { clave: spaceData });
    navigate('/');
  };

  const handleSubmit = async (values, onWorkspaces) => {
    setLoading(true);
    setError(null);
    try {
      await onWorkspaces(values);
    } catch (err) {
      setError('Error workspaces. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  return {
    loading,
    error,
    handleSubmit,
    goToWorkspaceMap,
  };
};
